import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Card,
  Chip,
  Container,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useContext, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

import { Loading } from "../../components/loading";
import { ElectionContext, INTERFACE_STATE } from "./election.context";
import { AuthContext } from "../../context/auth.provider";
import React from "react";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import { LinkBtn } from "../../components/lnk-btn";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckIcon from "@mui/icons-material/Check";
import BallotIcon from "@mui/icons-material/Ballot";
import { RESPONSE_TYPE } from "../../const/vote";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { ItemLabel } from "../../components/item-label";
import { RenderHtml } from "../../components/render-html";
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import { CustomLogo } from "../../components/custom-logo";
import InfoIcon from '@mui/icons-material/InfoOutlined';
import { DisplaySchedule } from "../../components/display-schedule";
import { ApiBallot, ApiIQuestion, ISubmitState } from "../../domain/election";
import { sortDisplayOrder } from "./util";

export const ElectionOverviewPage = () => {
  const { election, ballots, submitStateMap, voter } = useContext(ElectionContext);



  const initialOpen = useMemo(() => {
    for (const ballot of ballots) {
      const status = submitStateMap[ballot.id];
      if (!status.self_submitted || status.proxy_submitted === false) return ballot.id;
    }
    if (ballots.length > 0) {
      return ballots[0].id;
    }
  }, [ballots]);

  console.log({ voter, election, ballots, initialOpen })

  if (!voter || !election || !ballots) {
    return <Loading source="ElectionPanel" waitingFor={{ election, ballots }} />;
  }

  const { voting_schedule } = election;

  return (
    <Container maxWidth={"lg"}>
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h4" >{election.label}</Typography>
          {election.logo_lg_url ?
            <Box
              width="100%"
              maxHeight="300px"
              height="100%"
              display="flex"
              alignItems="center"
              justifyContent="center"
              p={{ xs: 3, md: 4 }}
              boxSizing="border-box">
              <Box maxWidth="500px" maxHeight="100%" height="100%">
                <CustomLogo url={election.logo_lg_url} size="w600" />
              </Box>
            </Box> : null}
          <hr />
          {
            election.short_description
              ? <>
                <RenderHtml html={election.short_description} />
                <hr />
              </>
              : null
          }
        </Grid>
        <Grid item xs={12}>
          {voting_schedule ? <DisplaySchedule schedule={voting_schedule} /> : null}
        </Grid>

        <Grid item xs={12} mt={1}>
          <hr />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">Logged in as: {voter.email}</Typography>
          <Typography variant="caption">(Your vote will be anonymous)</Typography>
          <hr />
        </Grid>
        <Grid item xs={12} mt={2}>
          <BallotsList ballots={ballots} initialOpen={initialOpen} />
        </Grid>
        {/* <Grid item xs={12} mt={4}>
          <ElectionState />
        </Grid> */}
      </Grid>
    </Container >
  );
};



interface BallotsProps {
  ballots: ApiBallot[];
  initialOpen?: string;
}
const BallotsList = ({ ballots, initialOpen }: BallotsProps) => {
  const { submitStateMap } = useContext(ElectionContext);

  if (ballots.length === 0) {
    return <Typography>No questions available</Typography>
  }
  if (ballots.length === 1) {
    const ballot = ballots[0];
    const submitted = submitStateMap[ballot.id].self_submitted && submitStateMap[ballot.id].proxy_submitted !== false;
    return (
      <>
        <Box pb={4}>
          {ballot.label ? <Typography variant="h6">{ballot.label}</Typography> : null}
          {ballot.short_description && ballot.short_description != ""
            ? <Box sx={{ mt: 1, p: 2, mb: 1, borderRadius: 3, background: "#e4ebf3", whiteSpace: "pre-line", display: 'flex', flexDirection: 'row' }}>
              <Box sx={{ pl: 1, pr: 2, py: 1 }}>
                <InfoIcon />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography>{ballot.short_description}</Typography>
              </Box>
            </Box>
            : null
          }


          <QuestionsList questions={Object.values(ballot.questions)} enabled={ballot.status === "ENABLED"} submitted={submitted} />

        </Box>
        <PageAction ballot={ballot} />
      </>
    )
  }
  return (<>{ballots.map((b, i) => (
    <BallotCard
      key={b.id}
      ballot={b}
      initialOpen={initialOpen === b.id}
      submitState={submitStateMap[b.id]}
    />
  ))}</>)
}

interface BallotCardProps {
  ballot: ApiBallot;
  initialOpen: boolean;
  submitState: ISubmitState;
}
export const BallotCard = ({
  ballot,
  initialOpen,
  submitState
}: BallotCardProps) => {
  const questions = useMemo(
    () => Object.values(ballot.questions),
    [ballot]
  );
  const submitted = submitState.self_submitted && submitState.proxy_submitted !== false;
  const enabled = ballot.status === "ENABLED";
  const icon = useMemo(() => {
    if (submitted) {
      return (<TaskAltIcon
        color="success"
        sx={{ marginRight: 2, top: 4, position: 'relative' }}
      />)
    }
    if (enabled) {
      return (<HowToVoteIcon
        color={"interface" as any}
        sx={{ marginRight: 2 }}
      />)
    }
    return (<DoDisturbIcon
      color="disabled"
      sx={{ marginRight: 2 }}

    />)
  }, [submitted, enabled])
  return (
    <Accordion
      defaultExpanded={initialOpen}
      sx={{
        border: "solid 1px",
        borderColor: "#AAA",
        boxShadow: `0px 2px 1px -1px rgba(0,0,0,0.14),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)`,
        background: (enabled ? undefined : "#F5F5F5")
      }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        {icon}
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          alignItems="center"
        >
          <ItemLabel label={ballot.label} required={ballot.required} />
          {submitted ? (
            <Chip
              variant="outlined"
              color="success"
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <span>Submitted</span>
                  <CheckIcon sx={{ marginLeft: 1 }} />
                </Box>
              }
            />
          ) : null}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box paddingLeft={2}>
          <QuestionsList questions={questions} enabled={enabled} submitted={submitted} />
        </Box>

        {enabled ? <Box display="flex" justifyContent="center">
          <PageAction ballot={ballot} />
        </Box> : <Typography>Not yet available for voting</Typography>}
      </AccordionDetails>
    </Accordion>
  );
};

interface QuestionsListProps {
  questions: ApiIQuestion[];
  enabled: boolean;
  submitted: boolean;
}

const QuestionsList = ({ questions, enabled, submitted }: QuestionsListProps) => {
  const _questions = useMemo(
    () => Object.values(questions).sort(sortDisplayOrder),
    [questions]
  );

  return <List
    sx={{
      width: "100%",
      boxSizing: "border-box",
    }}
  >
    {_questions.map((q, i) => (
      <QuestionCard key={q.id} question={q} index={i} enabled={enabled} submitted={submitted} />
    ))}
  </List>
}

interface QuestionCardProps {
  index: number;
  question: ApiIQuestion;
  enabled: boolean;
  submitted: boolean;
}
const QuestionCard = ({ question, index, enabled, submitted }: QuestionCardProps) => {
  const { candidates, response_type } = question;
  const _enabled = enabled && question.status === "ENABLED"
  const highlight = useMemo(() => {
    if (submitted || !enabled || question.status !== "ENABLED") {
      return null
    }
    switch (response_type) {
      case RESPONSE_TYPE.PREFERENCE:
      case RESPONSE_TYPE.CHECK_LIST:
        if (candidates) {
          const _candidates = Object.values(candidates);
          return `(${_candidates.length} candidates)`;
        }
        return "no options"
      case RESPONSE_TYPE.YES_NO:
        return "Yes/No"
    }
  }, [question, candidates, response_type])
  const icon = useMemo(() => {
    if (submitted) {
      return <BallotIcon color={"success" as any} />
    }
    if (_enabled) {
      return <BallotIcon color={"interface" as any} />
    }
    return <DoDisturbIcon color="disabled" />
  }, [submitted, enabled])
  return (
    <>
      {index > 0 ? <Divider variant="inset" component="li" /> : null}
      <ListItem alignItems="flex-start" sx={{ width: "100%" }}>
        <ListItemAvatar>
          {icon}
        </ListItemAvatar>
        <ListItemText
          primary={<ItemLabel label={question.label} required={question.required} />}
          secondary={
            <span>
              {highlight}
              <br />
              <RenderHtml html={question.short_description} />
            </span>}
        />
      </ListItem>
    </>
  );
};

interface PageActionProps {
  ballot: ApiBallot;
}
const PageAction = ({ ballot }: PageActionProps) => {
  const { interfaceState, submitStateMap, voter } = useContext(ElectionContext);

  const { election_id } = useParams();
  const submitState = submitStateMap[ballot.id];

  const submitted = submitState.self_submitted && submitState.proxy_submitted !== false;

  if (submitted) {
    return (<Box display="flex" justifyContent="center" width="100%">

      <Chip
        variant="outlined"
        color="success"
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <span>Submitted</span>
            <CheckIcon sx={{ marginLeft: 1 }} />
          </Box>
        }
      />
    </Box>)
  }

  switch (interfaceState) {
    case INTERFACE_STATE.VOTING_ALLOWED:
      return (<LinkBtn
        to={`/voting/${election_id}/ballot/${ballot.id}/vote`}
        variant="contained"
        fullWidth
        color={"interface" as any}
      >
        Begin
      </LinkBtn>)

    case INTERFACE_STATE.ELECTION_ALREADY_CLOSED:
      return (
        <Typography>
          Voting for this election has closed. Thank you for your interest.
        </Typography>
      );

    case INTERFACE_STATE.ELECTION_NOT_YET_OPEN:
      return (
        <Typography>
          This election is not yet open for voting. Please come back after voting opens.
        </Typography>
      );

    case INTERFACE_STATE.ALREADY_SUBMITTED:
      return (
        <Card variant="outlined" sx={{ marginTop: 10 }}>
          <Box p={3} sx={{ background: "#fbf7e9" }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography>
                  You have already submitted responses to all eligible questions
                  in this election.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Link to={`/voting/${election_id}/dispute`}>
                  <Button fullWidth>
                    Haven't voted yet?
                    <br />
                    Click here if you believe this is an error.
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Card>
      );

    case INTERFACE_STATE.LOADING:
      return <span>loading...</span>;
  }
  return null;
};




const ElectionState = () => {
  const { election_id } = useParams();
  const { interfaceState } = useContext(ElectionContext);


  switch (interfaceState) {

    case INTERFACE_STATE.ELECTION_ALREADY_CLOSED:
      return (
        <Typography>
          Voting for this election has closed. Thank you for your interest.
        </Typography>
      );

    case INTERFACE_STATE.ELECTION_NOT_YET_OPEN:
      return (
        <Typography>
          This election is not yet open for voting. Please come back after voting opens.
        </Typography>
      );

    case INTERFACE_STATE.ALREADY_SUBMITTED:
      return (
        <Card variant="outlined" sx={{ marginTop: 10 }}>
          <Box p={3} sx={{ background: "#fbf7e9" }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography>
                  You have already submitted responses to all eligible questions
                  in this election.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Link to={`/voting/${election_id}/dispute`}>
                  <Button fullWidth>
                    Haven't voted yet?
                    <br />
                    Click here if you believe this is an error.
                  </Button>
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Card>
      );

    case INTERFACE_STATE.LOADING:
      return <span>loading...</span>;
  }
  return null;
};
